module.exports = __webpack_public_path__ + "static/media/B-flat-7ths.402727c1.png";